<template>
  <section id="about">
    <v-container fluid class="about-section py-16">
      <v-row align="center" justify="center">
        <v-col cols="10" lg="8">
          <v-row align="center" justify="center">
            <v-col cols="12" md="7">
              <p class="section-overline mb-2">SOBRE</p>
              <h2 class="section-title mb-3">
                Uma plataforma pensada para cada perfil
              </h2>
              <p class="section-subtitle mb-8">
                Do paciente ao profissional, todos se beneficiam.
              </p>

              <div class="about-item mb-6" v-for="(item, i) in items" :key="i">
                <div class="about-icon-wrapper mr-5">
                  <v-icon color="primary" size="24">{{ item.icon }}</v-icon>
                </div>
                <div>
                  <h4 class="about-item-title mb-1">{{ item.title }}</h4>
                  <p class="about-item-text mb-0">{{ item.text }}</p>
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="5" class="d-none d-md-flex justify-center">
              <v-img
                src="@/assets/images/ill1.svg"
                class="d-block"
                max-width="360px"
                style="opacity: 0.9"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          icon: "mdi-account-heart",
          title: "Visão do Paciente",
          text: "Visualize de forma clara o andamento do tratamento, acompanhe consultas, orientações personalizadas e recomendações dietéticas — tudo em um único lugar.",
        },
        {
          icon: "mdi-stethoscope",
          title: "Ferramentas para Profissionais",
          text: "Gerencie consultas, acesse o histórico do paciente, controle a evolução do tratamento e tenha todas as informações para um atendimento personalizado.",
        },
        {
          icon: "mdi-file-document-outline",
          title: "Exames Compartilhados",
          text: "Acesse e compartilhe exames de forma segura. Analise resultados diretamente no sistema e ajuste o tratamento conforme necessário.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.about-section {
  background-color: var(--ds-gray-bg);
}

.section-overline {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  color: var(--ds-primary);
  text-transform: uppercase;
}

.section-title {
  font-size: 2.25rem;
  font-weight: 600;
  color: var(--ds-ink);
  letter-spacing: -0.3px;
  line-height: 1.2;
}

.section-subtitle {
  font-size: 1.05rem;
  font-weight: 300;
  color: var(--ds-gray);
  line-height: 1.6;
}

.about-item {
  display: flex;
  align-items: flex-start;
}

.about-icon-wrapper {
  min-width: 48px;
  height: 48px;
  border-radius: 12px;
  background: var(--ds-blue-100);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.about-item-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--ds-ink);
}

.about-item-text {
  font-size: 0.9rem;
  font-weight: 300;
  color: var(--ds-gray);
  line-height: 1.65;
}

@media (max-width: 960px) {
  .section-title {
    font-size: 1.75rem;
  }
}
</style>
